import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const cards = [
  { key: "bookings_total", label: "Booking requests", to: "/admin/bookings" },
  { key: "contacts_total", label: "Contact messages", to: "/admin/contacts" },
  { key: "poll_votes_total", label: "Facials poll votes", to: "/admin/poll" },
  { key: "blog_posts_total", label: "Blog posts", to: "/admin/blog" },
  { key: "newsletter_subscribers_total", label: "Newsletter subs", to: "/admin/analytics" },
  { key: "page_views_total", label: "Page views (all-time)", to: "/admin/analytics" },
];

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/admin/analytics`, { withCredentials: true });
        setStats(res.data);
      } catch (e) {
        setErr(e?.response?.data?.detail || "Failed to load");
      }
    })();
  }, []);

  return (
    <section data-testid="admin-overview">
      <h2 className="font-serif text-3xl md:text-4xl font-light mb-8 tracking-tight">
        Studio overview
      </h2>
      {err && <p className="text-red-600 text-sm mb-4">{err}</p>}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {cards.map(({ key, label, to }) => (
          <Link
            key={key}
            to={to}
            data-testid={`stat-card-${key}`}
            className="block bg-white border border-[#D9CFA0] rounded-lg p-6 hover:shadow-md transition-shadow"
          >
            <div className="text-xs uppercase tracking-wider text-[#0F1F4E]/70 mb-2">{label}</div>
            <div className="font-serif text-4xl text-[#0F1F4E]">
              {stats ? (stats[key] ?? 0) : "—"}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
